// src/analytics/sentry.js
export async function setupSentry(dsn, env) {
  const DSN = dsn ?? import.meta.env.VITE_SENTRY_DSN;
  const ENV = env ?? (import.meta.env.VITE_APP_ENV || 'production');
  if (!import.meta.env.PROD || !DSN) return;

  const Sentry = await import('@sentry/react');
  const { browserTracingIntegration /*, replayIntegration*/ } = Sentry;
  Sentry.init({
    dsn: DSN,
    integrations: [browserTracingIntegration()],
    tracesSampleRate: 0.1,
    environment: ENV,
  });
  return Sentry;
}
